import { keepTrackApi } from '@app/keepTrackApi';
import { Line, LineColors } from './line';
export class SatToCelestialBodyLine extends Line {
    sat;
    body;
    constructor(sat, body) {
        super();
        this.sat = sat;
        this.body = body;
        this.color_ = LineColors.CYAN;
    }
    update() {
        const eci = this.sat.eci(keepTrackApi.getTimeManager().simulationTimeObj);
        if (!eci) {
            this.isGarbage = true;
            return;
        }
        const eciArr = [eci.position.x, eci.position.y, eci.position.z];
        this.updateVertBuf([eciArr, keepTrackApi.getScene().getBodyById(this.body).position]);
    }
}
